import React, { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
import FileUploadDisplay from '../../components/FileUploadDisplay';

const UploadCertificate = ({ onFileSelect, initialFile, showValidation }) => {
	const [currentFile, setCurrentFile] = useState(null);
	const [showError, setShowError] = useState(false);

	useEffect(() => {
		if (initialFile && currentFile !== initialFile) {
			if (initialFile instanceof File) {
				setCurrentFile(initialFile);
			} else if (typeof initialFile === 'string') {
				setCurrentFile(initialFile);
			} else if (initialFile && typeof initialFile === 'object') {
				if (initialFile.url) {
					setCurrentFile(initialFile.url);
				} else if (initialFile.data) {
					const file = new File([initialFile.data], initialFile.name || 'certificate.pdf', {
						type: 'application/pdf',
					});
					setCurrentFile(file);
				}
			}
		}
		if (!initialFile && currentFile) {
			setCurrentFile(null);
		}
		// eslint-disable-next-line
	}, [initialFile]);

	const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
		accept: { 'application/pdf': [] },
		maxFiles: 1,
		onDrop: (files) => {
			// Only allow files <= 3MB
			const validFiles = files.filter((file) => file.size <= 3 * 1024 * 1024);
			if (validFiles.length === 0) {
				setShowError(true);
				toast.error('File too large. Maximum allowed size is 3MB.');
				return;
			}
			setCurrentFile(validFiles[0]);
			onFileSelect(validFiles[0]);
			toast.success('Certificate selected successfully');
		},
	});

	const handleRemoveFile = () => {
		setCurrentFile(null);
		onFileSelect(null);
		toast.info('Certificate removed');
	};

	useEffect(() => {
		if (showValidation) {
			setShowError(!currentFile);
		} else {
			setShowError(false);
		}
	}, [showValidation, currentFile]);

	return (
		   <>
			   <div className="dropzone">
				   <div {...getRootProps({ className: 'dropzone-upload-wrapper' })}>
					   <input {...getInputProps()} />
					   <div className="dropzone-inner-wrapper">
						   {isDragAccept && (
							   <div>
								   <div className="d-100 btn-icon mb-3 hover-scale-lg bg-success shadow-success-sm rounded-circle text-white" />
								   <div className="font-size-sm text-success">PDF file accepted!</div>
							   </div>
						   )}
						   {isDragReject && (
							   <div>
								   <div className="d-100 btn-icon mb-3 hover-scale-lg bg-danger shadow-danger-sm rounded-circle text-white" />
								   <div className="font-size-sm text-danger">Only PDF files are allowed!</div>
							   </div>
						   )}
						   {!isDragActive && (
							   <div className="upload_detail text-center">
								   <img src="/assets/images/upload.svg" alt="Upload" />
								   <h4>
									   Last Qualification Certificate <span style={{ color: 'red' }}>*</span>
								   </h4>
								   <h5>Upload transcripts & final certificate in PDF (max 3MB)</h5>
								   {showError && (
									   <div className="mt-2">
										   <div className="alert alert-danger text-center" role="alert">
											   Certificate is required. Please upload your degree certificate to proceed.
										   </div>
									   </div>
								   )}
							   </div>
						   )}
					   </div>
				   </div>
			   </div>
			   {currentFile && (
				   <div className="mt-3">
					   <FileUploadDisplay
						   file={currentFile}
						   onRemove={handleRemoveFile}
						   showDownload={true}
						   showView={true}
						   showRemove={true}
					   />
				   </div>
			   )}
		   </>
	);
};

export default UploadCertificate;
